export const PRODUCTS_PER_PAGE = 24;

export const PITCHES_PER_PAGE = 12;
